<template>
    <div class="page-ctas" :class="{
        'has-wave': styled,
    }">
        <WithWave v-bind="{ styled: styled && 'yes' }" />
        
        <nav data-grid class="cta-nav" aria-label="Explore">
            <ul>
                <li>
                    <router-link class="cta-nav__link" :to="internalCta.route" aria-label="Connect with us">
                        <span>Learn more </span>
                        <div data-flex="row">
                            <span aria-hidden="true" class="button button--white">Learn More</span>
                            <strong class="title title--light">{{ internalCta.title }}</strong>
                        </div>
                        <img class="cta-nav__bg" loading="lazy" decoding="async" src="/static/img/cta-connect.jpg" alt="">
                    </router-link>
                </li>
                <li>
                    <a class="cta-nav__link" href="//instagram.com/doanegrantthorntoncareers/" target="_blank" rel="noopener" aria-label="Read our stories - opens in new tab">
                        <span>What&rsquo;s it like? </span>
                        <div data-flex="row">
                            <span aria-hidden="true" class="button button--white">Learn More</span>
                            <strong class="title title--light">Watch our stories</strong>
                        </div>
                        <img class="cta-nav__bg" loading="lazy" decoding="async" :src="storiesImage" alt="">
                    </a>
                </li>
            </ul>
        </nav>
        
    </div>
</template>

<script>
import WithWave from '../Builder/WithWave.vue';

export default {
    props: {
        styled: {
            type: Boolean,
            default: false,
        },
    },

    components: {
        WithWave,
    },

    data: () => ({
        activeTab: 0,
        resizer: null,
    }),

    computed: {
        internalCta() {
            if ( this.$route.fullPath.includes('campus-microsite')) {
                return {
                    title: 'Read our stories',
                    route: { name: 'slide' },
                }
            }
            if ( this.$route.fullPath.includes('kevin-ladner-scholarship')) {
                return {
                    title: 'Campus resources',
                    route: { name: 'campus-resources-video' },
                }
            }
            return {
                title: 'Connect with us',
                route: '/connect-with-us/',
            }
        },
        storiesImage() {
            const { type } = this.$store.getters.user
            if ( this.$route.fullPath.includes('/discover-your') && type === 'student' ) {
                return '/static/img/cta-stories-campus.jpg'
            }
            return '/static/img/cta-stories.jpg'
        },
    },
}
</script>

<style lang="scss" scoped>
.page-ctas {
    background: var(--purple);
    padding-block: 3rem;
    position: relative;
    overflow-inline: clip;
    --outline-offset: 3px;
}

.title--light {
    margin-top: auto;
    color: currentColor;
}

.cta-nav {
    max-width: 1200px;
    isolation: isolate;

    ul {
        gap: var(--ul-gap, 1rem);
        display: grid;
    }

    li:not(:hover) a::before {
        opacity: .75;
    }
}

.cta-nav__link {
    color: #fff;
    position: relative;
    background: #0001;
    display: flex;
    flex-direction: column;
    border-radius: 1rem;
    overflow: hidden;
    padding: 1.5rem;
    gap: var(--item-gap, .5rem);

    &::before {
        content: '';
        --color-fade: 40%;
        --color-mix: color-mix(in srgb, var(--purple) var(--color-fade), #000);
        position: absolute;
        inset: 0;
        background: linear-gradient(to top, var(--color-mix) var(--hover-dist, 20%), color-mix(in srgb, var(--color-mix) var(--color-fade), #0000));
        transition: opacity .2s ease;
        transition-property: opacity, --hover-dist;
        opacity: .5;
        z-index: -1;
    }

    > [data-flex] {
        position: relative;
    }

    .button {
        --btn-height: 44px;
        --btn-font-size: 13px;
        padding: 0 2rem;
    }
}

.cta-nav__bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    
    position: absolute;
    inset: 0;
    z-index: -2;

    backface-visibility: hidden;
    transform: scale(1);
}

@media (width <= 767px) {
    .cta-nav__link .button {
        margin: 140px auto 0 0;
        order: 1;
    }
}

@media (width > 767px) {
    .page-ctas {
        padding-block: 5rem;
    }

    .cta-nav ul {
        display: flex;
        flex-wrap: nowrap;
        --ul-gap: 2%;
        --item-gap: 30ch;
    }

    .cta-nav__link {
        padding: 2rem;

        > span {
            font-size: 85%;
        }
        .button {
            position: absolute;
            opacity: 0;
            right: 0;
            top: 50%;
            translate: 0 -50%;
            transition: opacity 0.3s;
        }
    }

    .cta-nav li {
        flex-grow: 1;
        transition: flex-grow 0.825s var(--timing);

        &:hover {
            flex-grow: var(--hover-grow, 2);
        }
        a:focus-visible .button,
        &:hover .button {
            opacity: 1;
            transform: translateX(0);
        }
    }
}
@media (width > 1023px) {
    .page-ctas {
        padding-block: 8rem;
    }
    .cta-nav ul {
        --hover-grow: 3;
    }
}
</style>